<template>
  <account-select :account_list="account_list"/>
</template>
<script>

  import {createNamespacedHelpers} from 'vuex';
  import {TALENTQ_STORE_NAMES} from "@/stores_new/vacancy_talentq/constants";
  import AccountSelect from "@/routes_new/inner/vacancy/talentq/controllers/account/select";

  const {mapActions, mapGetters} = createNamespacedHelpers('vacancy_talentq/' + TALENTQ_STORE_NAMES.ACCOUNT_LIST);

  export default {
    name: "account-list",
    components: {
      AccountSelect,
    },
    computed: {
      ...mapGetters(['loaded', 'error', 'data']),
      account_list () {
        return {
          loaded: this.loaded,
          error: this.error,
          data: this.data,
        }
      }
    },
    methods: {
      ...mapActions(['load'])
    },
    created () {
      this.load();
    }
  }
</script>